<template>
  <div class="monitor_wrap" style="height: calc(100% - 40px);">
    <div class="mainHead">
      <div class="route">
        <span class="crumbs"></span><span>综合查询</span>
      </div>
    </div>
    <div class="fixedScorll" style="height: calc(100% - 58px);">
      <div class="main clearfix">
        <!-- <div class="main_left"> -->
        <div class="main_left" style="height: calc(100% - 10px);">
          <div class="maindetails">
            <div class="clearfix">
              <div class="detailsName">
                <span>建筑名称:</span>&nbsp;&nbsp;
                <span>{{BuildingDatil.buildingName}}</span>
              </div>
              <div class="detailsDevice">
                <span>监测设备数:</span>&nbsp;&nbsp;
                <span>{{deviceNum}} (启用) </span> <span style="display:inline-block;margin: 0 10px">|</span>
                <span> {{failCount}} (禁用)</span>
              </div>
            </div>
            <div class="detailAddress">
              <span>建筑地址:</span>&nbsp;&nbsp;
              <span v-html="this.BuildingDatil.address">{{BuildingDatil.detailAddress}}</span>
            </div>
          </div>
          <todo-List :routerWarnManger="this.routerUrl" :tabArray="tabArray" :detailsArray="detailsArray" style="height: calc(100% - 138px);" @listenType="listenType" @listenSearch="listenSearch" @listenSeav="listenSeav"></todo-List>

        </div></div>
    </div>

  </div>
</template>

<script>
  import todoList from '../../components/todoList';
  import {ajaxFuncJson} from '@/api/ajax';
  require('echarts/theme/macarons'); // echarts theme
  export default {
    name: 'searchWarnIndex',
    components: {
      todoList
    },
    data () {
      return {
        msg: '监控中心',
        activeName: 'second',
        routerUrl:'searchWarnDetail',
        heightBg:'',
        heightCard:'',
        parms:{
          customerId:'',
          buildingId:'',
          runStatus:[],
          connectStatus:[],
          searchName:"",
          deviceStatus:[],
          type:[],
          enabled:[],
          deal_status:'',
          flag:true,
        },
        scrollHeight:'',
        BuildingDatil:{
            buildingName:'',
            detailAddress:''
        },
        deviceNum:'',
        failCount:'',
        detailsArray:[],
        tabArray:[],
        widthNum: '',   //中间区域自适应宽度
        widthCard: '', //计算卡片宽度
        widthText: '', //计算卡片文本宽度
        total: 0,  //实时监控总计
        cydata:[],  //实时监测类型告警Y轴标题
        dataList:[  //实时报警处理情况数据
          {value:0, name:'待处理'},
          {value:0, name:'处理中'},
          {value:0, name:'审核中'},
        ],
        searchInput:'',

        monitorList:[   //实时监控数据
          {
            name:'正常',
            percentage:0,
            value:0,
          },
          {
            name:'告警',
            percentage:0,
            value:0,
          },
          {
            name:'离线',
            percentage:0,
            value:0,
          },
          {
            name:'故障',
            percentage:0,
            value:0,
          },
        ],
        isShowDot:false,
        windowResize:null,
      }
    },
    created() {
      this.$emit('getItem', false); //是否显示左侧新增建筑图标
      if(this.isAuth('common:interface')){
        this.getTabListAtax();//获取TAB设备类型
      }
      if(sessionStorage.getItem('ruleFormOption') && sessionStorage.getItem('returnType') == '1'){
        let ruleFormOption = JSON.parse(sessionStorage.getItem('ruleFormOption'));
        if(ruleFormOption){
          this.parms.deviceStatus = ruleFormOption.deviceStatusVal; //赋值Type选择值
          this.parms.runStatus = ruleFormOption.monitorStateVal; //赋值Type选择值
          this.parms.connectStatus = ruleFormOption.communicationStateVal; //赋值Type选择值
          this.parms.enabled = ruleFormOption.pointStateVal; //赋值Type选择值
          // this.getDetailsList();
        }
      }else{
         this.getDetailsList(); //获取详情信息
      }
    },
    computed:{
      getMap() {
        return this.$store.state.buildingId
      }
    },
    watch: {
      getMap (newV, oldV) { // status的变化，然后执行操作
        if(this.isAuth('common:interface')){
          this.getTabListAtax();//获取TAB设备类型
        }
        this.getDetailsList(); //获取详情信息
      }
    },
    methods:{
      isScroll(){
        this.$nextTick(()=>{
          let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
            cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
          if(sHeight>cHeight){
            document.getElementsByClassName('maindetails')[0].style.marginRight=0;
            document.getElementsByClassName('mainList')[0].style.marginRight=0;
          }else {
            document.getElementsByClassName('maindetails')[0].style.marginRight='1.05%';
            document.getElementsByClassName('mainList')[0].style.marginRight='1.05%';
          }
        });
      },
      // tab组件切换
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      //跳转详情路由
      hrefDetail(){
        this.$router.push({path:'/content/warnDetail',query:{id:'123'}}); //进入非监测点详情页
      },

      listenType(data){ //监听子组件Tab
        if(data == '0'){
          this.parms.type = []; //赋值Type选择值
        }else{
          this.parms.type = data; //赋值Type选择值
        }
        this.getDetailsList();
      },
      listenSearch(data){//子:失去焦点查询
        this.parms.searchName = data; //赋值Type选择值
        this.getDetailsList();
      },
      listenSeav(data){ //监听子组件保存
        this.parms.deviceStatus = data.deviceStatusVal; //赋值Type选择值
        this.parms.runStatus = data.monitorStateVal; //赋值Type选择值
        this.parms.connectStatus = data.communicationStateVal; //赋值Type选择值
        this.parms.enabled = data.pointStateVal; //赋值Type选择值
        this.getDetailsList();
      },
      getTabListAtax(){ //获取Tab列表选项
        let parms = {
          buildingId: sessionStorage.getItem("buildingId"),//赋值建筑id
          customerId: sessionStorage.getItem("customerId"),//赋值客户id
          remark:"true",
          dealStatus:[0,1,2,3],
          target: '2',
        }
        ajaxFuncJson('/basicData/getMonitorType',parms).then(res=>{
          if(res.data.status == 200){
              this.tabArray = [];//先清空
              this.tabArray = res.data.data; //获取Tab列表选项
              let totalNum = 0;
              this.tabArray.forEach((a,b)=>{
                    totalNum += a.warnNum;
              })
            let Objective = {
                flag: true,
                name: "全部",
                type: '',
                warnNum: totalNum,
              }
            this.tabArray.unshift(Objective);
          }
        })
      },
      getDetailsList(){ //获取详情
          if(this.isAuth('common:interface')) {
            this.parms.buildingId = sessionStorage.getItem("buildingId");//赋值建筑id
            this.parms.customerId = sessionStorage.getItem("customerId");//赋值客户id
            this.parms.deal_status=[0,1,2,3];
            this.parms.target = '2',
            ajaxFuncJson('/basicData/getMonitorByMultipleMatching',this.parms).then(res=>{
              if(res.data.status == 200){
                let analysis= res.data.data;
                if(analysis.BuildingDatil){
                  this.BuildingDatil = analysis.BuildingDatil; //赋值监测点详情
                                                  if(this.BuildingDatil.address == this.BuildingDatil.detailAddress){
                                    this.BuildingDatil.address = (this.BuildingDatil.detailAddress).replace(/\|/g, "<span style='margin:0 10px'>|</span>")
                                }else{
                                    this.BuildingDatil.address = (this.BuildingDatil.address +'|'+ this.BuildingDatil.detailAddress).replace(/\|/g, "<span style='margin:0 10px'>|</span>")
                                }
                }
                this.deviceNum = analysis.deviceNum; //赋值监测点详情
                this.failCount = analysis.failCount; //赋值监测点详情
                this.detailsArray = analysis.monitorByMultipleMatching; //赋值监测点详情
                this.isScroll();
                this.$store.state.listenerIsWarn=true;
                this.$store.state.routerUrl=true;
              }
            })
          }
      },
    },
    mounted() {
      let that = this;
      that.windowResize=function () {
        that.scrollHeight=$('body').height()-71-$('.mainHead').outerHeight()-10;
        that.heightBg =  that.scrollHeight -148;
        that.isScroll();
      };
      that.windowResize();
      window.addEventListener('resize',that.windowResize);
    },
    destroyed(){
      let _this=this;
      window.removeEventListener("resize",_this.windowResize)
    }
  }
</script>
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .main{
    height: 100%;
  }
  .main .maindetails{
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 30px 0 30px 40px;
    font-size:14px ;
    color: #282828 ;
    .detailsName{
      float: left;
      width: 420px;
      padding-bottom: 30px;
    }
    .detailsDevice{
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/warningManger/searchWarnIndex.vue